import React, { useState, useEffect } from 'react';
import { Form, Button, Alert, Spinner, Card, Accordion } from 'react-bootstrap';
import axios from '../utils/api';
import RichTextEditor from './RichTextEditor';
import './AdminDashboard.css';

function AboutEditor() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    bio: '',
    education: '',
    location: '',
    email: ''
  });

  useEffect(() => {
    fetchAbout();
  }, []);

  const fetchAbout = async () => {
    try {
      const response = await axios.get('/content/simple-content?type=about');
      const data = response.data.data;
      if (data) {
        setFormData({
          name: data.name || '',
          bio: data.bio || '',
          education: data.education || '',
          location: data.location || '',
          email: data.email || ''
        });
      }
    } catch (err) {
      setError('Failed to load about information');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setSaving(true);

    try {
      await axios.put('/content/simple-content?type=about', formData);
      setSuccess('About information updated successfully');
      fetchAbout();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to update about information');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="text-center"><Spinner animation="border" /> Loading...</div>;
  }

  return (
    <div className="editor-card">
      <div className="editor-header">
        <h3>👤 Edit About Section</h3>
      </div>
        {error && <Alert variant="danger" className="alert-admin" dismissible onClose={() => setError('')}>{error}</Alert>}
        {success && <Alert variant="success" className="alert-admin" dismissible onClose={() => setSuccess('')}>{success}</Alert>}

        <Form onSubmit={handleSubmit} className="admin-form">
          <Accordion defaultActiveKey="0" alwaysOpen>
            <Accordion.Item eventKey="0" className="mb-3">
              <Accordion.Header>
                <h4 className="mb-0" style={{ color: '#667eea', fontSize: '1.2rem' }}>📝 Personal Information</h4>
              </Accordion.Header>
              <Accordion.Body>
                <Card className="mb-3" style={{ backgroundColor: '#f8f9fa', border: '1px solid #e0e0e0' }}>
                  <Card.Body>
                    <Form.Group className="mb-3">
                      <Form.Label><strong>Name *</strong></Form.Label>
                      <Form.Control
                        type="text"
                        value={formData.name}
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        required
                        placeholder="Your full name"
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label><strong>Location</strong></Form.Label>
                      <Form.Control
                        type="text"
                        value={formData.location}
                        onChange={(e) => setFormData({ ...formData, location: e.target.value })}
                        placeholder="City, Country"
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label><strong>Email *</strong></Form.Label>
                      <Form.Control
                        type="email"
                        value={formData.email}
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        required
                        placeholder="your.email@example.com"
                      />
                    </Form.Group>
                  </Card.Body>
                </Card>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1" className="mb-3">
              <Accordion.Header>
                <h4 className="mb-0" style={{ color: '#667eea', fontSize: '1.2rem' }}>📖 Bio & Background</h4>
              </Accordion.Header>
              <Accordion.Body>
                <Card className="mb-3" style={{ backgroundColor: '#f8f9fa', border: '1px solid #e0e0e0' }}>
                  <Card.Body>
                    <Form.Group className="mb-3">
                      <Form.Label><strong>Professional Bio *</strong></Form.Label>
                      <RichTextEditor
                        value={formData.bio}
                        onChange={(value) => setFormData({ ...formData, bio: value })}
                        placeholder="Write your professional bio here. This will be displayed in the About section of your portfolio..."
                        rows={8}
                      />
                      <Form.Text className="text-muted">A detailed description of yourself, your experience, and what you do. Use the toolbar above to format your text (Bold, Italic, Lists, etc.).</Form.Text>
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label><strong>Education *</strong></Form.Label>
                      <RichTextEditor
                        value={formData.education}
                        onChange={(value) => setFormData({ ...formData, education: value })}
                        placeholder="Your educational background, degrees, certifications, etc..."
                        rows={4}
                      />
                      <Form.Text className="text-muted">Your academic qualifications and certifications. Use the toolbar above to format your text.</Form.Text>
                    </Form.Group>
                  </Card.Body>
                </Card>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          <div className="mt-4 d-flex justify-content-end">
            <Button className="btn-primary-admin" type="submit" disabled={saving} style={{ minWidth: '200px' }}>
              {saving ? '💾 Saving...' : '💾 Save All Changes'}
            </Button>
          </div>
        </Form>
    </div>
  );
}

export default AboutEditor;

